import { useParams } from 'react-router-dom'

import { PageRoomProvider } from 'shared/context/project-room'

const withRoom = <P extends object>(
  Component: React.ComponentType<P>
) => {
  return (props: P) => {
    const { projectId } = useParams()

    return (
      <PageRoomProvider projectId={projectId!}>
        <Component {...props} />
      </PageRoomProvider>
    )
  }
}

export default withRoom
